import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LogoutButton from './LogoutButton';
import { FaCog, FaUsers, FaChalkboardTeacher, FaGraduationCap, FaChartBar, FaChevronDown } from 'react-icons/fa';

const UserProfile = () => {
    const { currentUser, userProfile, isAdmin } = useAuth();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (!currentUser) {
        return null;
    }

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <div className="flex items-center space-x-4">
                <div className="text-right">
                    <p className="text-sm font-medium text-gray-900">
                        {userProfile?.firstName && userProfile?.lastName 
                          ? `${userProfile.firstName} ${userProfile.lastName}`
                          : currentUser.displayName || currentUser.email
                        }
                    </p>
                    <p className="text-xs text-gray-500">
                        {currentUser.email}
                    </p>
                    {userProfile?.role && (
                        <p className="text-xs text-blue-600 font-medium">
                            {userProfile.role.charAt(0).toUpperCase() + userProfile.role.slice(1)}
                        </p>
                    )}
                </div>
                
                <div className="flex items-center space-x-2">
                    <div className="h-8 w-8 rounded-full bg-primary flex items-center justify-center">
                        <span className="text-white text-sm font-medium">
                            {(userProfile?.firstName || currentUser.displayName || currentUser.email).charAt(0).toUpperCase()}
                        </span>
                    </div>
                    
                    {isAdmin() && (
                        <button
                            onClick={toggleDropdown}
                            className="p-1 rounded-md hover:bg-gray-100 transition-colors"
                        >
                            <FaChevronDown className={`h-4 w-4 text-gray-600 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
                        </button>
                    )}
                </div>
                
                <LogoutButton className="text-sm">
                    Sign Out
                </LogoutButton>
            </div>

            {/* Admin Dropdown Menu */}
            {isAdmin() && isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                    <div className="py-1">
                        <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                            Admin Panel
                        </div>
                        
                        <Link
                            to="/admin"
                            onClick={() => setIsDropdownOpen(false)}
                            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                        >
                            <FaCog className="mr-3 h-4 w-4 text-gray-400" />
                            Dashboard
                        </Link>
                        
                        <Link
                            to="/admin?tab=users"
                            onClick={() => setIsDropdownOpen(false)}
                            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                        >
                            <FaUsers className="mr-3 h-4 w-4 text-gray-400" />
                            User Management
                        </Link>
                        
                        <Link
                            to="/admin?tab=teachers"
                            onClick={() => setIsDropdownOpen(false)}
                            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                        >
                            <FaChalkboardTeacher className="mr-3 h-4 w-4 text-gray-400" />
                            Teacher Management
                        </Link>
                        
                        <Link
                            to="/admin?tab=sessions"
                            onClick={() => setIsDropdownOpen(false)}
                            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                        >
                            <FaGraduationCap className="mr-3 h-4 w-4 text-gray-400" />
                            Learning Sessions
                        </Link>
                        
                        <Link
                            to="/admin?tab=analytics"
                            onClick={() => setIsDropdownOpen(false)}
                            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                        >
                            <FaChartBar className="mr-3 h-4 w-4 text-gray-400" />
                            Analytics
                        </Link>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserProfile; 